// extracted by mini-css-extract-plugin
var _1 = "ApplicantIdentityWidgetReadView-moduleApplicantIdentityWidgetReadView__SGqy7";
var _2 = "ApplicantIdentityWidgetReadView-modulerows__cfdAW";
export { _1 as "ApplicantIdentityWidgetReadView", _2 as "rows" }
